import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { WorkspacePage } from './workspace.page';
import { DashboardPage } from './dashboard/dashboard.page';
import { ComponentsModule } from '../components/components.module';
import { BadgesPage } from './badges/badges.page';
import { AnalyzePage } from './analyze/analyze.page';
import { TranslateModule } from '@ngx-translate/core';
import { HideOnScrollDirective } from '../directives/hide-on-scroll.directive';
import { MobxAngularModule } from 'mobx-angular';
import { RouteDataGuard } from '../guards/route-data-guard';
import { OnboardingModule } from '../components/onboarding/onboarding.module';
import { SharedComponentsModule } from '../components/shared-components/shared-components.module';
import { PostingModule as NetsocialPostingModule } from 'netsocial-posting/src/app/posting/posting.module';
import { SharedComponentsModule as SharedPM } from 'netsocial-posting/src/app/components/shared-components/shared-components.module';
import { ChannelModule } from '../components/channel/channel.module';
import { AppShellModule } from '../components/app-shell/app-shell.module';
import { PostingModule } from '../components/posting/posting.module';
import { JoyrideModule } from 'ngx-joyride';
import { ChangePasswordPage } from './change-password/change-password.page';
import { DashboardModule } from '../components/dashboard/dashboard.module';
import { AnalyticsModule } from '../components/analytics/analytics.module';
import { LeaderboardPage } from './leaderboard/leaderboard.page';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { PROMISE_BUTTONS_MODULE_OPTIONS } from 'netsocial-posting/src/app/utils/constants';

const routes: Routes = [
  {
    path: '',
    component: WorkspacePage,
    children: [
      {
        path: '',
        component: DashboardPage,
        data: {
          title: 'dashboardTitle',
          icon: 'speedometer-outline',
          notificationName: 'dashboard',
        },
      },
      {
        path: 'content',
        loadChildren: () => import('./content/content.module').then((m) => m.ContentPageModule),
        data: {
          title: 'contentTitle',
          altTitle: 'curateAltTitle',
          icon: 'images-outline',
          canActivate: {
            accountTypes: ['myself', 'company'],
          },
        },
        canActivate: [RouteDataGuard],
      },
      {
        path: 'queue',
        loadChildren: () => import('./queue/queue.module').then((m) => m.QueuePageModule),
        data: {
          title: 'queueTitle',
          altTitle: 'queueAltTitle',
          icon: 'calendar-outline',
          notificationName: 'queue',
          canActivate: {
            accountTypes: ['myself', 'company'],
          },
        },
        canActivate: [RouteDataGuard],
      },
      {
        path: 'social-accounts',
        loadChildren: () =>
          import('./social-accounts/social-accounts.module').then(
            (m) => m.SocialAccountsPageModule
          ),
        data: {
          title: 'socialAccountsTitle',
          icon: 'share-social-outline',
          notificationName: 'socialAccounts',
          canActivate: {
            accountTypes: ['myself', 'company'],
          },
        },
        canActivate: [RouteDataGuard],
      },
      {
        path: 'manage-all',
        loadChildren: () => import('./manage-all/manage-all.module').then((m) => m.ManageAllModule),
        data: {
          title: 'manageAllTitle',
          icon: 'person-outline',
          canActivate: {
            permissions: ['teams', 'agency'],
            accountTypes: ['company', 'agency'],
          },
          notificationName: 'manageAll',
          hideEditor: true,
        },
        canActivate: [RouteDataGuard],
      },
      {
        path: 'manage-clients',
        loadChildren: () =>
          import('./manage-clients/manage-clients.module').then((m) => m.ManageClientsPageModule),
        data: {
          title: 'manageClientTitle',
          icon: 'people-circle',
          canActivate: {
            permissions: ['agency'],
            accountTypes: ['agency'],
            // TODO ADD BACK MULTI-CLIENT AND FRANCHISE
            // permissions: ['multipleClients', 'franchises', 'agency'],
            // TODO ADD BACK COMPANY WHEN THIS WORKS
            // accountTypes: ['company', 'agency'],
          },
          notificationName: 'manageClients',
          hideEditor: true,
          agencyOrFranchiseOnly: true,
        },
        canActivate: [RouteDataGuard],
      },
      {
        path: 'badges',
        component: BadgesPage,
        data: {
          title: 'badgesTitle',
          icon: 'ribbon',
          hide: true,
          notificationName: 'badges',
          canActivate: {
            accountTypes: ['myself', 'company'],
          },
        },
        canActivate: [RouteDataGuard],
      },
      {
        path: 'leaderboard',
        component: LeaderboardPage,
        data: {
          title: 'leaderboardTitle',
          icon: 'trophy',
          // hide: true,
          notificationName: 'leaderboard',
        },
      },
      {
        path: 'analyze',
        component: AnalyzePage,
        data: {
          title: 'analyzeTitle',
          altTitle: 'analyzeAltTitle',
          icon: 'trending-up',
          notificationName: 'analyze',
        },
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsPageModule),
        data: {
          title: 'settingsTitle',
          icon: 'settings-outline',
          simplePage: true,
          notificationName: 'settings',
        },
      },
      {
        path: 'change-password',
        component: ChangePasswordPage,
        data: {
          title: 'changePasswordTitle',
          icon: 'key',
          notificationName: 'changePassword',
          hide: true,
        },
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule,
    TranslateModule.forChild(),
    MobxAngularModule,
    OnboardingModule,
    SharedComponentsModule,
    NetsocialPostingModule,
    ChannelModule,
    AppShellModule,
    PostingModule,
    DashboardModule,
    AnalyticsModule,
    JoyrideModule.forChild(),
    Angular2PromiseButtonModule.forRoot(PROMISE_BUTTONS_MODULE_OPTIONS),
    SharedPM,
  ],
  declarations: [
    WorkspacePage,
    DashboardPage,
    BadgesPage,
    LeaderboardPage,
    ChangePasswordPage,
    AnalyzePage,
    HideOnScrollDirective,
  ],
})
export class WorkspacePageModule {}
